import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ScheduledJobsList from './ScheduledJobsList';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const CurrentScheduledJobs = () => {
  const [scheduledJobs, setScheduledJobs] = useState([]);
  const [nodeScheduledJobs, setNodeScheduledJobs] = useState([]);
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    // 스케줄된 작업을 가져옵니다.
    fetch('/Acution/scheduled-jobs')
      .then(response => response.json())
      .then(data => {
        setScheduledJobs(data.dbScheduledJobs || []);
        setNodeScheduledJobs(data.nodeScheduledJobs || []);
      })
      .catch(error => {
        console.error('현재 스케줄된 작업을 가져오는 중 오류 발생:', error);
      });
  }, []);

  useEffect(() => {
    // 1초마다 현재 시간을 업데이트하여 실시간 남은 시간을 계산
    const timer = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const calculateRemainingTime = (expirationTime) => {
    if (!expirationTime) {
      return '예약되지 않음';
    }

    const now = new Date(currentTime);
    const expiration = new Date(expirationTime);
    const diff = expiration - now;

    if (diff <= 0) {
      return '만료됨';
    }

    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    let timeString = '';
    if (hours > 0) {
      timeString += `${hours}시간 `;
    }
    if (minutes > 0 || hours > 0) {
      timeString += `${minutes}분 `;
    }
    timeString += `${seconds}초 남음`;

    return timeString;
  };

  // scheduledJobs를 기반으로 할당된 작업과 공개 작업을 분류합니다.
  const assignedJobs = scheduledJobs?.filter(
    job => job.agent_status === 'assigned' || job.agent_status === 'reassigned' ||  job.agent_status === 'awarded'
  );
  const publicJobs = scheduledJobs?.filter(
    job => job.agent_status === 'public_action' || job.agent_status === 'public_reaction' || job.agent_status === 'last_action'
  );

  return (
    <Container>
      <Column>
        <h2>할당된 작업</h2>
     <ScheduledJobsList
        scheduledJobs={assignedJobs}
        calculateRemainingTime={calculateRemainingTime}
      />
      </Column>
      <Column>
        <h2>공개 작업</h2>
        <ScheduledJobsList
        scheduledJobs={publicJobs}
        calculateRemainingTime={calculateRemainingTime}
      />
      </Column>
      <Column>
        <h2>노드 스케줄된 작업</h2>
        <ScheduledJobsList
          scheduledJobs={nodeScheduledJobs}
          calculateRemainingTime={calculateRemainingTime}
          isNodeSchedule // 노드 스케줄용 플래그 전달
        />
      </Column>
    </Container>
  );
};

export default CurrentScheduledJobs;